import Vue from 'vue'
import Router from 'vue-router'
import screenSelector from './views/screenSelector.vue'
import brandStyle from './views/brandStyle.vue'
import marketCompetition from './views/marketCompetition.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: screenSelector
    },
    {
      path: '/2',
      name: 'Brand Style',
      component:brandStyle
    },
    {
      path: '/3',
      name: 'Market Competition',
      component:marketCompetition
    },
    {
    path: '/404',
    name: 'Error'
    }
  ]
})
